import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Success from "./pages/Success";
import Funnel from "./pages/Funnel";
import { Toaster } from "./components/ui/sonner";
import "./styles/Home.css";
import "./styles/Success.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/success" element={<Success />} />
            <Route path="/probeer-gratis" element={<Funnel />} />
            <Route path="/try-free" element={<Funnel />} />

            {/* Account & onboarding are app-only. Redirect any direct hits home. */}
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="/signup" element={<Navigate to="/" replace />} />
            <Route path="/dashboard" element={<Navigate to="/" replace />} />
            <Route path="/welcome" element={<Navigate to="/" replace />} />
            <Route path="/settings" element={<Navigate to="/" replace />} />
            <Route path="/subscription" element={<Navigate to="/" replace />} />
            <Route path="/subscription/success" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;

